import creator from './creator';

import {
  SERIAL_FETCH_START,
  SERIAL_FETCH_END,
  SERIALCOURSE_FETCH_START,
  SERIALCOURSE_FETCH_END,
 } from '../constants'

 // 获取组合卡片包含的多个课程
export const serialCourseFetchStart = creator(SERIALCOURSE_FETCH_START)
export const serialCourseFetchEnd = creator(SERIALCOURSE_FETCH_END, 'data', 'rank')
export function serialCourseFetch(serialCourseId, rank, query) {
  return async function serialCourseAction(dispatch, getState, { ds }) {
    dispatch(serialCourseFetchStart())
    try {
      const resp = await ds.serialCourse({
        id: serialCourseId,
        rank,
        ...query,
      })
      const { data } = await resp.json()
      dispatch(serialCourseFetchEnd(data, rank))
    } catch (error) {
      console.log(error) // eslint-disable-line no-console
    }
  }
}

// 优惠券组合卡片
export const serialFetchStart = creator(SERIAL_FETCH_START)
export const serialFetchEnd = creator(SERIAL_FETCH_END, 'data')
export function serialFetch(courseIds) {
  return async function serialFetchAction(dispatch, getState, { ds }) {
    dispatch(serialFetchStart())
    const resp = await ds.serial(courseIds)
    const { code, data } = await resp.json()
    if (code === '0') dispatch(serialFetchEnd(data))
  }
}



// WEBPACK FOOTER //
// ./src/actions/serial.js